/**
 * Tenant-scoped localStorage helpers.
 *
 * Keys are namespaced by tenant slug so that sessions in different tenant tabs
 * don't collide.  e.g. token_acme, user_acme.
 *
 * The slug is resolved from (in order):
 *   1. An explicit slug passed to the function
 *   2. The first path segment of the current URL  (/:tenantSlug/…)
 */

function currentSlug() {
  const seg = window.location.pathname.split('/')[1];
  // "admin" is the program-admin route — treat it like a tenant for storage
  return seg || '';
}

function scopedKey(key, slug) {
  const s = slug || currentSlug();
  return s ? `${key}_${s}` : key;
}

// ── token ──────────────────────────────────────────────────────────────

export function getToken(slug) {
  return localStorage.getItem(scopedKey('token', slug));
}

export function setToken(token, slug) {
  localStorage.setItem(scopedKey('token', slug), token);
}

export function removeToken(slug) {
  localStorage.removeItem(scopedKey('token', slug));
}

// ── user ───────────────────────────────────────────────────────────────

export function getUser(slug) {
  const raw = localStorage.getItem(scopedKey('user', slug));
  return raw ? JSON.parse(raw) : null;
}

export function setUser(userData, slug) {
  localStorage.setItem(scopedKey('user', slug), JSON.stringify(userData));
}

export function removeUser(slug) {
  localStorage.removeItem(scopedKey('user', slug));
}

// ── terminology cache ──────────────────────────────────────────────────
// Last resolved terminology map, so an offline reload keeps the tenant's words.

export function getCachedTerms(slug) {
  try {
    const raw = localStorage.getItem(scopedKey('terms', slug));
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
}

export function setCachedTerms(terms, slug) {
  try {
    localStorage.setItem(scopedKey('terms', slug), JSON.stringify(terms));
  } catch (e) {
    // storage blocked or full — the cache is best-effort
  }
}
